import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'

export const FormContainer = styled(Container)`
  max-width: 600px;
`

export const ButtonContainer = styled(Container)`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
`

export const InfoContainer = styled(Container)`
  margin-bottom: 2rem;
`

export const FormField = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const Label = styled.label`
  font-weight: 500;
  color: ${({theme}) => theme.colors.primary.main};
  font-size: ${({theme}) => theme.fontSize.sm};
`

export const RequiredIndicator = styled.span`
  color: ${({theme}) => theme.colors.red};
`
